import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    list: {},
    checkedRows: []
}

export const raspberryEraseStationSlice = createSlice({
    name: 'raspberryEraseStation',
    initialState,
    reducers: {
        refreshList: (state, action) => {
            state.list = action.payload
        },
        refreshOne: (state, action) => {
            state.list[action.payload.id] = action.payload.raspberryEraseStation;
        },
        setCheckedRows: (state, action) => {
            if (!state.checkedRows.includes(action.payload)) {
                state.checkedRows = [...state.checkedRows, action.payload];
            }
        },
        uncheckRow: (state, action) => {
            state.checkedRows = state.checkedRows.filter((tableDataID) => tableDataID!==action.payload);
        }
    },
})

export const { refreshList, refreshOne, setCheckedRows, uncheckRow } = raspberryEraseStationSlice.actions

export default raspberryEraseStationSlice.reducer